<template>
    <footer ref="footerRef">
        <div class="bg-leonard-black">
            <div class="container grid md:grid-cols-[auto_1fr] place-items-center md:place-items-stretch mx-auto p-4">
                <div class="place-content-center">
                    <a href="https://www.leonards.com" class="text-leonard-white hover:text-leonard-white-hover" target="_blank" title="Leonard's Studio">
                        <Logo class="h-20 w-auto"></Logo>
                    </a>
                </div>
                <div class="place-content-center justify-items-end">
                    <button type="button"
                            class="hidden md:grid gap-1 place-items-center items-center p text-leonard-white hover:text-leonard-white opacity-100 hover:opacity-70 cursor-pointer"
                            @click="scrollToTop"
                    >
                        <ArrowUp></ArrowUp>
                        <small>Scroll To Top</small>
                    </button>
                </div>
            </div>
        </div>
        <div class="hidden md:block bg-leonard-black" v-if="loggedIn() && isEmployee">
            <div class="container columns-1 md:columns-2 xl:columns-3 gap-6 mx-auto p-4">
                <nav class="break-inside-avoid">
                    <h6 class="mb-1 text-leonard-white">Employees &amp; Officers</h6>
                    <ul>
                        <li>
                            <a class="grid grid-cols-[auto_1fr] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-white hover:text-leonard-white opacity-70 hover:opacity-100"
                               target="_blank" rel="noopener noreferrer" title="School Administrative Portal"
                               href="https://schooladmin.leonards.com">
                                <span class="-left-6 -ml-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link">
                                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                                    </svg>
                                </span>
                                School Administrative Portal
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="md:bg-leonard-white">
            <div class="grid xl:grid-cols-[auto_1fr_auto] md:container md:mx-auto md:gap-2 xl:gap-6 md:p-4 items-center">
                <p class="bg-leonard-white md:bg-transparent order-3 xl:order-1 p-4 md:p-0 text-center">&copy; {{(new Date).getFullYear()}} Leonard&apos;s Studio</p>
                <nav class="p-4 md:p-0 bg-leonard-black md:bg-transparent order-2">
                    <ul class="flex flex-col md:flex-row gap-2 md:gap-6 justify-center items-center xl:justify-start">
                        <li class="relative group">
                            <a class="
                               grid grid-cols-1 md:grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap
                               text-leonard-white md:text-leonard-green hover:text-leonard-white md:hover:text-leonard-green-hover
                               opacity-70 md:opacity-100 hover:opacity-100
                            "
                               target="_blank" rel="noopener noreferrer" title="Privacy Policy Page"
                               href="https://www.leonards.com/privacy-policy">
                                Privacy Policy
                            </a>
                        </li>
                        <li class="relative group">
                            <a class="
                               grid grid-cols-1 md:grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap
                               text-leonard-white md:text-leonard-green hover:text-leonard-white md:hover:text-leonard-green-hover
                               opacity-70 md:opacity-100 hover:opacity-100
                           "
                               target="_blank" rel="noopener noreferrer" title="Shipping, Cancellations and Returns Page"
                               href="https://www.leonards.com/shipping-cancellations-and-returns">
                                Shipping, Cancellations and Returns
                            </a>
                        </li>
                    </ul>
                </nav>
                <div data-component="SocialMedia" class="grid bg-leonard-black md:bg-transparent p-4 md:p-0 order-1 md:order-3">
                    <h2 class="h6 mb-3 text-leonard-white text-center md:hidden">Follow Us On:</h2>
                    <nav class="flex space-x-4 md:space-x-2 justify-center xl:justify-end">
                        <a class="
                          flex items-center justify-center aspect-1/1 rounded-full md:rounded h-10 md:h-8 w-10 md:w-8 text-lg md:text-base
                          text-leonard-green md:hover:text-leonard-green-hover bg-leonard-white md:bg-transparent hover:bg-leonard-white-hover md:hover:bg-transparent
                       "
                           target="_blank" rel="noopener noreferrer" title="Leonard's Official Facebook Page"
                           href="https://www.facebook.com/LeonardsPhotography">
                            <font-awesome-icon :icon="['fab', 'facebook-f']" aria-label="Facebook Icon"></font-awesome-icon>
                        </a>
                        <a class="
                          flex items-center justify-center aspect-1/1 rounded-full md:rounded h-10 md:h-8 w-10 md:w-8 text-lg md:text-base
                          text-leonard-green md:hover:text-leonard-green-hover bg-leonard-white md:bg-transparent hover:bg-leonard-white-hover md:hover:bg-transparent
                       "
                           target="_blank" rel="noopener noreferrer" title="Leonard's Official Instagram Page"
                           href="https://www.instagram.com/leonards_photo/">
                            <font-awesome-icon :icon="['fab', 'instagram']" aria-label="Instagram Icon"></font-awesome-icon>
                        </a>
                        <a class="
                          flex items-center justify-center aspect-1/1 rounded-full md:rounded h-10 md:h-8 w-10 md:w-8 text-lg md:text-base
                          text-leonard-green md:hover:text-leonard-green-hover bg-leonard-white md:bg-transparent hover:bg-leonard-white-hover md:hover:bg-transparent
                       "
                           target="_blank" rel="noopener noreferrer" title="Leonard's Official LinkedIn Page"
                           href="https://www.linkedin.com/company/leonard%27s">
                            <font-awesome-icon :icon="['fab', 'linkedin-in']" aria-label="LinkedIn Icon"></font-awesome-icon>
                        </a>
                        <a class="
                          flex items-center justify-center aspect-1/1 rounded-full md:rounded h-10 md:h-8 w-10 md:w-8 text-lg md:text-base
                          text-leonard-green md:hover:text-leonard-green-hover bg-leonard-white md:bg-transparent hover:bg-leonard-white-hover md:hover:bg-transparent
                       "
                           target="_blank" rel="noopener noreferrer" title="Leonard's Official YouTube Page"
                           href="https://www.youtube.com/channel/UCN19uCo0kGO9gRC1dtZFdhg">
                            <font-awesome-icon :icon="['fab', 'youtube']" aria-label="YouTube Icon"></font-awesome-icon>
                        </a>
                    </nav>
                </div>
            </div>
        </div>
        <button type="button"
                title="Scroll to Top"
                class="font-medium transition-all duration-300 border-2 rounded-full fixed z-50 block p-2 bg-leonard-black border-leonard-white text-leonard-white hover:bg-leonard-black-hover hover:border-transparent focus:ring-leonard-black cursor-pointer bottom-4 right-4"
                :class="{ 'opacity-100 pointer-events-auto': isVisible, 'opacity-0 pointer-events-none': !isVisible }"
                @click="scrollToTop"
        >
            <ArrowUp></ArrowUp>
        </button>
    </footer>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faFacebook, faInstagram, faPinterest, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
    import Logo from "../icons/Logo.vue";
    import SocialMedia from "../partials/SocialMedia.vue";
    import ArrowUp from "../icons/ArrowUp.vue";

    export default {
        components: {ArrowUp, SocialMedia, Logo},
        data() {
            return {
                isVisible: false,
                isIntersecting: false,
                footerRef: null,
                observer: null
            }
        },

        created() {
            library.add(faFacebook, faInstagram, faPinterest, faTwitter, faYoutube);
        },

        mounted() {
            this.footerRef = this.$refs.footerRef;

            this.observer = new IntersectionObserver(
                ([entry]) => {
                    this.isIntersecting = entry.isIntersecting;
                    if (entry.isIntersecting) {
                        this.isVisible = false;
                    }
                },
                { threshold: 0.1 }
            );

            if (this.footerRef) {
                this.observer.observe(this.footerRef);
            }

            window.addEventListener('scroll', this.handleScroll);
        },

        beforeDestroy() {
            if (this.footerRef) {
                this.observer.unobserve(this.footerRef);
            }

            window.removeEventListener('scroll', this.handleScroll);
        },

        methods: {
            handleScroll() {
                this.isVisible = window.scrollY > 0 && !this.isIntersecting;
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }
</script>
